<p>
  This EC2 instance is configured for real-time replication of data updates. To enable this, the Elastic Disaster
  Recovery Service agent must be installed on the machine and configured to replicate to the
  <span class="code">{{ region }}</span> region in account <span class="code">{{ awsAccountId }}</span
  >. Until this agent is installed, {{ uiService.productName }} will replicate this server via EBS snapshots.
</p>
<p>
  Follow <a href="{{ uiService.drsAgentInstallationInstructionsUrl }}" target="_blank">these instructions</a> to install
  this agent on this EC2 instance.
</p>
<p>
  If you would prefer to have {{ uiService.productName }} replicate this server using EBS snapshots,
  <a [routerLink]="" (click)="showConfirmEbsSnapshotReplicationDialog()">click here.</a>
</p>

<modal-dialog #ConfirmEbsSnapshotReplicationDialog [dialogTemplate]="confirmManualReplicationConfig"></modal-dialog>
<ng-template #confirmManualReplicationConfig>
  <div class="flex-center-column full-width">
    <div class="dialog light-content-panel double-margin-top">
      <div class="flex-center-row">
        <h3 class="panel-title">Replication with EBS Snapshots</h3>
      </div>

      <div class="margin-top">
        You're choosing to replicate this server via EBS Snapshots. Here's what that means:
        <ol>
          <li>
            The Elastic Disaster Recovery service will not be used to replicate this server's data as it is updated.
          </li>
          <li>
            Instead, {{ uiService.productName }} will take frequent snapshots of the server's disks and copy them to the
            recovery environment.
          </li>
          <li>
            During a recovery, this server will be re-created from these snapshots, and the very latest data from the
            server may not be included.
          </li>
          <li>But you will not need to install an agent on the server, and your AWS bill will be lower.</li>
        </ol>
        Choose Use Snapshots to proceed, or Cancel to go back.
      </div>
      <div class="flex-center-row double-margin-top full-width">
        <div class="spacer"></div>
        <button class="arpio-secondary-button" (click)="dismissEbsSnapshotReplicationDialog()">CANCEL</button>
        <button busy-button [busy]="saving" class="arpio-button margin-left" (click)="confirmEbsSnapshotReplication()">
          USE SNAPSHOTS
        </button>
        <div class="spacer"></div>
      </div>
    </div>
  </div>
</ng-template>
